import { Card, Row, Col, Stack, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import { PersonFill } from "react-bootstrap-icons"

import "./UserEntry.scss"
import timeService from "../../services/time/timeService"

export interface UserEntryProps {
    _id: string
    firstName: string
    lastName: string
    email: string
    lastLogin?: Date
    profilePic?: string
    role: string
    extraButtons?: any[]
}

const UserEntry: React.FC<UserEntryProps> = ({
    _id,
    firstName,
    lastName,
    email,
    lastLogin,
    role,
    profilePic,
    extraButtons
}) => {
    return (
        <Card className="user-entry">
            <Card.Body>
                <Row>
                    <Col xs={2} className="d-flex align-items-center justify-content-center">
                        <div className="avatar-circle rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, border: '2px solid #eee', overflow: 'hidden' }}>
                            {profilePic ? (
                                <img src={profilePic} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                                <PersonFill size={24} color="#6c757d" />
                            )}
                        </div>
                    </Col>
                    <Col>
                        <Card.Title>
                            {firstName} {lastName}
                        </Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">
                            {role}
                        </Card.Subtitle>
                        <Card.Text>
                            <small>
                                <b>Email:</b> {email} <br />
                                <b>Last Login:</b> {lastLogin ? timeService.getFormattedTime(new Date(lastLogin)) : 'N/A'} <br />
                            </small>
                        </Card.Text>
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer>
                <Stack direction="horizontal" gap={2}>
                    <Link to={`/user/${_id}`} className="btn btn-primary btn-sm">View</Link>
                    {extraButtons && extraButtons.map((button, idx) => (
                        <Button
                            key={idx}
                            size="sm"
                            variant={button.variant || 'secondary'}
                            disabled={button.disabled}
                            onClick={() => button.onClick && button.onClick({ _id, firstName, lastName, email, lastLogin, role, profilePic })}
                        >
                            {button.label}
                        </Button>
                    ))}
                </Stack>
            </Card.Footer>
        </Card>
    )
}

export default UserEntry
